import React, {Component, PropTypes} from 'react';
import TextField from 'material-ui/TextField';
import validate from '../../services/validation';
import DatePicker from 'material-ui/DatePicker';
import Event from 'material-ui/svg-icons/action/date-range';
import IconButton from 'material-ui/IconButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'underscore';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            $valid: false,
            $pristine: true,
            $touched: false,
            $invalid: true,
            $dirty: false,
            $focused: false,
            invalidMessages: null,
            value: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.next = _.debounce(this.next, 400);
    }
    
    componentWillMount() {
        let valid = this.state.$valid,
            dirty = this.state.$dirty;
        
        if (this.props.val) {
            valid = this.validate(this.props.val);
            dirty = true;
        }

        if (!this._getRules()) valid = true;
        
        this.setState({value: this.props.val, $valid: valid, $invalid: !valid, $dirty: dirty});
    }
    
    componentWillReceiveProps(nextProps) {

        let value = this.state.$focused && this.props.editVal !== undefined ? nextProps.editVal : nextProps.val,
            valid = this.state.$valid;
        
        if (this.props.currency && this.state.$focused) value = (value+'').replace('.',',');

        if (this.value && !this.state.$focused) {
            valid = this.validate(value);
            _.delay(this.props.forceValidation, 400)();
        }

        this.setState({value: value, $valid: valid, $invalid: !valid}); 
    }

    
    
    onFocus(e) {
        let state = _.clone(this.state),
            value = state.value;

        if (this.props.editVal || this.props.editVal === 0) {
            if (!this.state.$dirty && this.props.currency) value = '';
            else {
                let editVal = this.props.editVal;
                if (this.props.currency) editVal = (editVal+'').replace('.',',');
                state.value = editVal;
            } 
        }

        state.$touched = true;
        state.$focused = true;
        state.$pristine = false;

        this.setState(state);

        e.persist();

        this.props.onFocus(e, e.target.value, state);
    }

    onBlur(e) {
        let state = _.clone(this.state);

        if (e.target.value.length > 0) {
            state.$dirty = true;
            if (!this.validate(e.target.value)) state.$valid = false;
        } 

        if (this.props.editVal || this.props.editVal === 0) {
            state.value = this.props.val;
            this.props.onBlur(e, e.target.value, true);
        }

        state.$focused = false;
        state.$invalid = !state.$valid;

        this.setState(state);

        this.props.onBlur(e, e.target.value, state);
    }

    onChange(e, value) {
        let valid = this.state.$valid,
            invalid = this.state.$invalid,
            dirty = this.state.$dirty,
            focused = this.state.$focused;

        if (dirty && !this.validate(value)) valid = false;
        else valid = true;

        if (this.props.currency && focused) {
            value = value.replace('.',',');
        }
        this.setState({$valid:valid, $invalid:!valid, $dirty:dirty, value: value});

         if (e && e.target.name) e.persist();
         else e = {target:{name:this.props.name, value:value}};

        this.next(e, e.target.value);
    }

    next(e, value) {
        if (this.props.onChange) this.props.onChange(e, e.target.value);
    }     

    validate(value) {
        let messages = [],
            rules = this._getRules();

        if (!rules) return true;

        messages = validate(value, rules);

        if (messages.length > 0) {
            this.setState({invalidMessages:messages.join(',')});
            return false;
        } 
        else {
            this.setState({invalidMessages:null});
            return true;
        } 
    }

    //GET VALIDATION RULES AS ARRAY
    _getRules() {
        const validations = this.props.validations;
        
        if (!validations) return false;

        return (this.props.validations.split(',').map((val) => val.split(':')));
    }

    render() {
        if (this.props.hide) return null;

        let options = null;

        const props = _.omit(this.props, [
            'validations',
            'outerClassName',
            'currency',
            'val',
            'tipo'
        ]);

        if (this.props.tipo === 'select') {
            options = this.props.items.map((item, index) => {
                return (
                    <MenuItem
                        key={item.codigo} 
                        value={item.codigo}
                        primaryText={item.label()}>

                    </MenuItem>
                );
            });
        }


        switch(this.props.tipo) {
            case 'date':
                return (
                    <div style={{position:'relative'}}>
                        <DatePicker 
                            {...props}
                            container="inline"
                            floatingLabelStyle={{color: this.context.muiTheme.palette.floatingLabelColor, zIndex:0}}
                            underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
                            errorText={this.state.invalidMessages}
                            onChange={this.onChange}
                            onBlur = {this.onBlur}
                            value={this.state.value}
                            ref="picker"
                            fullWidth={true}
                            />

                            <IconButton
                                onTouchTap={() => this.refs.picker.handleTouchTap()} 
                                style={{verticalAlign:'middle', position:'absolute', bottom:5, right:2, zIndex:0}}
                                >
                                <Event  />
                            </IconButton>
                    </div>
                );
                break;
            case 'select':
                return (
                    <SelectField 
                        {...props}
                        floatingLabelStyle={{color: this.context.muiTheme.palette.floatingLabelColor, zIndex: 0}}
                        underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
                        errorText={this.state.invalidMessages}
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        value={this.state.value}
                        fullWidth={true}>
                        {options}
                    </SelectField>
                );
                break;
            default:
                return (
                    <TextField 
                        {...props}
                        floatingLabelStyle={{color: this.context.muiTheme.palette.floatingLabelColor}}
                        underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
                        errorText={this.state.invalidMessages}
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        value={this.state.value}
                        fullWidth={true} />
                );
                break;

        }   
    }
}

Input.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

Input.PropTypes = {
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    currency: PropTypes.bool,
    validations: PropTypes.string.isRequired,
    val: PropTypes.isRequired,
    outerClassName: PropTypes.string,
};

export default Input;


/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/Input2.jsx
 **/